import { CardOrdering, CardTypes } from "@fresh8/types/src";
import {
  LIST_GROUP,
  MAIN_MARKET_GROUP,
  WDW_GROUP,
  WW_GROUP
} from "../../../constants/market-types";

import {
  MarketCard,
  EventGroup,
  CardCreationFunction,
  CreationContext,
  EventMarketGroups
} from "../types";

import { createH2HCard } from "./event/h2h";
import { createInsightCard } from "./event/insight";

import { createPromoCard } from "./event/promo";

import { createOfferCard } from "./general/offer";
import { createParlayCard } from "./general/parlay";

type MarketGroup = keyof EventMarketGroups;

/**
 * generic factory function for card creation, this includes WW WDW LIST and MAINMARKET
 * @params type (MarketGroupType)
 * @returns CardCreationFunction
 */

export function createCardCreationFunction(
  type: MarketGroup
): CardCreationFunction {
  return (event: EventGroup, _: CreationContext) => {
    let markets = event.markets[type];

    if (!markets) return [];

    if (type === "list") {
      markets = [markets[0]];
    }

    return [
      new MarketCard({
        type: type as CardTypes,
        eventId: event.id,
        marketIds: markets,
        optionIds: null
      })
    ];
  };
}

type EventCardCreationMap = Record<
  CardOrdering["event"][number],
  CardCreationFunction
>;

/**
 * Map of Event card creation functions keyed by card type, generic cards can use createCardCreationFunction see implementation above
 * if more detail logic is needed for creation, create a new file and map that create function to correct key
 */

export const eventCardCreationMap: EventCardCreationMap = {
  promo: createPromoCard,
  h2h: createH2HCard,
  list: createCardCreationFunction(LIST_GROUP),
  mainMarket: createCardCreationFunction(MAIN_MARKET_GROUP),
  insight: createInsightCard,
  wdw: createCardCreationFunction(WDW_GROUP),
  ww: createCardCreationFunction(WW_GROUP)
};

type GenerCardCreationMap = Record<
  Exclude<CardOrdering["general"][number], "events">,
  (eventgroup: EventGroup[], context: CreationContext) => Array<MarketCard>
>;

/**
 * Map of General card creation functions keyed by card type, create a new file and map its create function to correct key
 */

export const generalCardCreationMap: GenerCardCreationMap = {
  offer: createOfferCard,
  parlay: createParlayCard
};
